var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-animation-popup"},[_c('section',{staticClass:"animation-container"},[_c('success-animation')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }